import { twMerge } from 'tailwind-merge'

const themeStyle = 'blue';

//테마 스타일
const flowbiteThemeClasses = {
    blue: {
        background: 'bg-blue-700 dark:bg-blue-600',
        disabled: '',
        hover: 'hover:bg-blue-800 dark:hover:bg-blue-700',
        text: 'text-blue-600 dark:text-blue-500',
        border: 'border-blue-600 dark:border-blue-500',
        focus: 'focus:ring-blue-300 dark:focus:ring-blue-800',
    },
    green: {
        background: 'bg-green-700 dark:bg-green-600',
        disabled: '',
        hover: 'hover:bg-green-800 dark:hover:bg-green-700',
        text: 'text-green-600 dark:text-green-500',
        border: 'border-green-600 dark:border-green-500',
        focus: 'focus:ring-green-300 dark:focus:ring-green-800',
    },
    pink: {
        background: 'bg-pink-700 dark:bg-pink-600',
        disabled: '',
        hover: 'hover:bg-pink-800 dark:hover:bg-pink-700',
        text: 'text-pink-600 dark:text-pink-500',
        border: 'border-pink-600 dark:border-pink-500',
        focus: 'focus:ring-pink-300 dark:focus:ring-pink-900',
    },
    purple: {
        background: 'bg-purple-700 dark:bg-purple-600',
        disabled: '',
        hover: 'hover:bg-purple-800 dark:hover:bg-purple-700',
        text: 'text-purple-600 dark:text-purple-500',
        border: 'border-purple-600 dark:border-purple-500',
        focus: 'focus:ring-purple-300 dark:focus:ring-purple-900',
    },
    red: {
        background: 'bg-red-700 dark:bg-red-600',
        disabled: '',
        hover: 'hover:bg-red-800 dark:hover:bg-red-700',
        text: 'text-red-600 dark:text-red-500',
        border: 'border-red-600 dark:border-red-500',
        focus: 'focus:ring-red-300 dark:focus:ring-red-900',
    },
}

function useFlowbiteThemable() {
    const isActive = themeStyle != '';
    const theme = flowbiteThemeClasses[themeStyle];

    return { isActive, theme }
}

//Label 스타일
const labelClasses = {
    default: {
        default: 'block mb-2 text-sm font-medium',
        success: 'text-green-700 dark:text-green-500',
        error: 'text-red-700 dark:text-red-500',
        disabled: 'text-gray-900 dark:text-white',
    }
};

//Input 스타일
//https://flowbite.com/docs/forms/input-field/#input-fields
const inputClasses = {
    default: {
        default: 'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
        success: 'bg-green-50 border-green-500 dark:border-green-500 text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500 focus:ring-green-500 focus:border-green-500',
        error: 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500',
        disabled: 'cursor-not-allowed bg-gray-100',
    }
};

//Button 스타일
//https://flowbite.com/docs/components/buttons/#default-button
const buttonClasses = {
    default: {
        default: {
            default: 'text-white bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 focus:outline-none dark:focus:ring-blue-800',
            alternative: 'py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200  focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 ',
            dark: 'text-white bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-800 dark:focus:ring-gray-700 dark:border-gray-700',
            light: 'text-gray-900 bg-white border border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-800 dark:text-white dark:border-gray-600  dark:focus:ring-gray-700',
            green: 'focus:outline-none text-white bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-green-600 dark:focus:ring-green-800',
            red: 'focus:outline-none text-white bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-red-600 dark:focus:ring-red-900',
            yellow: 'focus:outline-none text-white bg-yellow-400 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:focus:ring-yellow-900',
            purple: 'focus:outline-none text-white bg-purple-700 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-purple-600 dark:focus:ring-purple-900',
            pink: '',
        },
        hover: {
            default: 'hover:bg-blue-800 dark:hover:bg-blue-700',
            alternative: 'hover:bg-gray-100 hover:text-blue-700 dark:hover:text-white dark:hover:bg-gray-700',
            dark: 'hover:bg-gray-900 dark:hover:bg-gray-700',
            light: 'hover:bg-gray-100 dark:hover:bg-gray-700',
            green: 'hover:bg-green-800 dark:hover:border-gray-600',
            red: 'hover:bg-red-800 dark:hover:bg-green-700',
            yellow: 'hover:bg-yellow-500 dark:hover:bg-red-700',
            purple: 'hover:bg-purple-800 dark:hover:bg-purple-700',
            pink: '',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            alternative: 'cursor-not-allowed opacity-50',
            dark: 'cursor-not-allowed opacity-50',
            light: 'cursor-not-allowed opacity-50',
            green: 'cursor-not-allowed opacity-50',
            red: 'cursor-not-allowed opacity-50',
            yellow: 'cursor-not-allowed opacity-50',
            purple: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
        },
    },
    //https://flowbite.com/docs/components/buttons/#outline-buttons
    outline: {
        default: {
            default: 'text-blue-700  border border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-blue-500 dark:text-blue-500 dark:focus:ring-blue-800',
            alternative: '',
            dark: 'text-gray-900  border border-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-gray-600 dark:text-gray-400 dark:focus:ring-gray-800',
            light: '',
            green: 'text-green-700  border border-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-green-500 dark:text-green-500 dark:focus:ring-green-800',
            red: 'text-red-700  border border-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:focus:ring-red-900',
            yellow: 'text-yellow-400  border border-yellow-400 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-yellow-300 dark:text-yellow-300 dark:focus:ring-yellow-900',
            purple: 'text-purple-700  border border-purple-700 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-purple-400 dark:text-purple-400 dark:focus:ring-purple-900',
            pink: '',
        },
        hover: {
            default: 'hover:text-white hover:bg-blue-800 dark:hover:text-white  dark:hover:bg-blue-500',
            alternative: '',
            dark: 'hover:text-white hover:bg-gray-900 dark:hover:text-white  dark:hover:bg-gray-600 ',
            light: '',
            green: 'hover:text-white hover:bg-green-800 dark:hover:text-white  dark:hover:bg-green-600 ',
            red: 'hover:text-white hover:bg-red-800 dark:hover:text-white  dark:hover:bg-red-600 ',
            yellow: 'hover:text-white hover:bg-yellow-500 dark:hover:text-white  dark:hover:bg-yellow-400 ',
            purple: 'hover:text-white hover:bg-purple-800 dark:hover:text-white  dark:hover:bg-purple-500 ',
            pink: '',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            alternative: 'cursor-not-allowed opacity-50',
            dark: 'cursor-not-allowed opacity-50',
            light: 'cursor-not-allowed opacity-50',
            green: 'cursor-not-allowed opacity-50',
            red: 'cursor-not-allowed opacity-50',
            yellow: 'cursor-not-allowed opacity-50',
            purple: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
        },
    },
    //https://flowbite.com/docs/components/buttons/#button-pills
    pills: {
        default: {
            default: '!rounded-full text-white bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 focus:outline-none dark:focus:ring-blue-800',
            alternative: '!rounded-full py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200  focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 ',
            dark: '!rounded-full text-white bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-800 dark:focus:ring-gray-700 dark:border-gray-700',
            light: '!rounded-full text-gray-900 bg-white border border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-800 dark:text-white dark:border-gray-600  dark:focus:ring-gray-700',
            green: '!rounded-full focus:outline-none text-white bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-green-600 dark:focus:ring-green-800',
            red: '!rounded-full focus:outline-none text-white bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-red-600 dark:focus:ring-red-900',
            yellow: '!rounded-full focus:outline-none text-white bg-yellow-400 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:focus:ring-yellow-900',
            purple: '!rounded-full focus:outline-none text-white bg-purple-700 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-purple-600 dark:focus:ring-purple-900',
            pink: '',
        },
        hover: {
            default: 'hover:bg-blue-800 dark:hover:bg-blue-700',
            alternative: 'hover:bg-gray-100 hover:text-blue-700 dark:hover:text-white dark:hover:bg-gray-700',
            dark: 'hover:bg-gray-900 dark:hover:bg-gray-700',
            light: 'hover:bg-gray-100 dark:hover:bg-gray-700',
            green: 'hover:bg-green-800 dark:hover:border-gray-600',
            red: 'hover:bg-red-800 dark:hover:bg-green-700',
            yellow: 'hover:bg-yellow-500 dark:hover:bg-red-700',
            purple: 'hover:bg-purple-800 dark:hover:bg-purple-700',
            pink: '',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            alternative: 'cursor-not-allowed opacity-50',
            dark: 'cursor-not-allowed opacity-50',
            light: 'cursor-not-allowed opacity-50',
            green: 'cursor-not-allowed opacity-50',
            red: 'cursor-not-allowed opacity-50',
            yellow: 'cursor-not-allowed opacity-50',
            purple: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
        },
    },
    //https://flowbite.com/docs/components/buttons/#gradient-monochrome
    monochrome: {
        default: {
            default: 'text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            blue: 'text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            green: 'text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            cyan: 'text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600  focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            teal: 'text-white bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600  focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            lime: 'text-gray-900 bg-gradient-to-r from-lime-200 via-lime-400 to-lime-500  focus:ring-4 focus:outline-none focus:ring-lime-300 dark:focus:ring-lime-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            red: 'text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600  focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            pink: 'text-white bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600  focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            purple: 'text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700  focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
        },
        hover: {
            default: 'hover:bg-gradient-to-br',
            blue: 'hover:bg-gradient-to-br',
            green: 'hover:bg-gradient-to-br',
            cyan: 'hover:bg-gradient-to-br',
            teal: 'hover:bg-gradient-to-br',
            lime: 'hover:bg-gradient-to-br',
            red: 'hover:bg-gradient-to-br',
            pink: 'hover:bg-gradient-to-br',
            purple: 'hover:bg-gradient-to-br',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            blue: 'cursor-not-allowed opacity-50',
            green: 'cursor-not-allowed opacity-50',
            cyan: 'cursor-not-allowed opacity-50',
            teal: 'cursor-not-allowed opacity-50',
            lime: 'cursor-not-allowed opacity-50',
            red: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
            purple: 'cursor-not-allowed opacity-50',
        },
    },
    //https://flowbite.com/docs/components/buttons/#gradient-duotone
    duotone: {
        default: {
            default: 'text-white bg-gradient-to-br from-purple-600 to-blue-500  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            purpleblue: 'text-white bg-gradient-to-br from-purple-600 to-blue-500  focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            cyanblue: 'text-white bg-gradient-to-r from-cyan-500 to-blue-500  focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            greenblue: 'text-white bg-gradient-to-br from-green-400 to-blue-600  focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            purplepink: 'text-white bg-gradient-to-r from-purple-500 to-pink-500  focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            pinkorange: 'text-white bg-gradient-to-br from-pink-500 to-orange-400  focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            teallime: 'text-gray-900 bg-gradient-to-r from-teal-200 to-lime-200  focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-teal-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            redyellow: 'text-gray-900 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200  focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            pink: '',
        },
        hover: {
            default: 'hover:bg-gradient-to-bl',
            purpleblue: 'hover:bg-gradient-to-bl',
            cyanblue: 'hover:bg-gradient-to-bl',
            greenblue: 'hover:bg-gradient-to-l',
            purplepink: 'hover:bg-gradient-to-bl',
            pinkorange: 'hover:bg-gradient-to-l',
            teallime: 'hover:from-teal-200 hover:to-lime-200',
            redyellow: 'hover:bg-gradient-to-bl',
            pink: '',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            purpleblue: 'cursor-not-allowed opacity-50',
            cyanblue: 'cursor-not-allowed opacity-50',
            greenblue: 'cursor-not-allowed opacity-50',
            purplepink: 'cursor-not-allowed opacity-50',
            pinkorange: 'cursor-not-allowed opacity-50',
            teallime: 'cursor-not-allowed opacity-50',
            redyellow: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
        },
    },
    //https://flowbite.com/docs/components/buttons/#colored-shadows
    colorshadow: {
        default: {
            default: 'text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            blue: 'text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            green: 'text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 shadow-lg shadow-green-500/50 dark:shadow-lg dark:shadow-green-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            cyan: 'text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 shadow-lg shadow-cyan-500/50 dark:shadow-lg dark:shadow-cyan-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            teal: 'text-white bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 shadow-lg shadow-teal-500/50 dark:shadow-lg dark:shadow-teal-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            lime: 'text-gray-900 bg-gradient-to-r from-lime-200 via-lime-400 to-lime-500 focus:ring-4 focus:outline-none focus:ring-lime-300 dark:focus:ring-lime-800 shadow-lg shadow-lime-500/50 dark:shadow-lg dark:shadow-lime-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            red: 'text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            pink: 'text-white bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 shadow-lg shadow-pink-500/50 dark:shadow-lg dark:shadow-pink-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
            purple: 'text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 shadow-lg shadow-purple-500/50 dark:shadow-lg dark:shadow-purple-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center',
        },
        hover: {
            default: 'hover:bg-gradient-to-br ',
            blue: 'hover:bg-gradient-to-br ',
            green: 'hover:bg-gradient-to-br ',
            cyan: 'hover:bg-gradient-to-br ',
            teal: 'hover:bg-gradient-to-br ',
            lime: 'hover:bg-gradient-to-br ',
            red: 'hover:bg-gradient-to-br ',
            pink: 'hover:bg-gradient-to-br ',
            purple: 'hover:bg-gradient-to-br ',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            blue: 'cursor-not-allowed opacity-50',
            green: 'cursor-not-allowed opacity-50',
            cyan: 'cursor-not-allowed opacity-50',
            teal: 'cursor-not-allowed opacity-50',
            lime: 'cursor-not-allowed opacity-50',
            red: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
            purple: 'cursor-not-allowed opacity-50',
        },
    },
    //https://flowbite.com/docs/components/buttons/#gradient-outline
    goutlineout: {
        default: {
            default: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800',
            purpleblue: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800',
            cyanblue: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800',
            greenblue: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800',
            purplepink: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-500 to-pink-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800',
            pinkorange: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-pink-500 to-orange-400 dark:text-white focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800',
            teallime: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-teal-300 to-lime-300 dark:text-white focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-lime-800',
            redyellow: 'relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-red-200 via-red-300 to-yellow-200 dark:text-white focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400',
            pink: '',
        },
        hover: {
            default: 'group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white',
            purpleblue: 'group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white',
            cyanblue: 'group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white ',
            greenblue: 'group-hover:from-green-400 group-hover:to-blue-600 hover:text-white ',
            purplepink: 'group-hover:from-purple-500 group-hover:to-pink-500 hover:text-white ',
            pinkorange: 'group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white ',
            teallime: 'group-hover:from-teal-300 group-hover:to-lime-300 dark:hover:text-gray-900 ',
            redyellow: 'group-hover:from-red-200 group-hover:via-red-300 group-hover:to-yellow-200 dark:hover:text-gray-900 ',
            pink: '',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            purpleblue: 'cursor-not-allowed opacity-50',
            cyanblue: 'cursor-not-allowed opacity-50',
            greenblue: 'cursor-not-allowed opacity-50',
            purplepink: 'cursor-not-allowed opacity-50',
            pinkorange: 'cursor-not-allowed opacity-50',
            teallime: 'cursor-not-allowed opacity-50',
            redyellow: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
        },
    },
    goutlinein: {
        default: {
            default: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            purpleblue: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            cyanblue: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            greenblue: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            purplepink: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            pinkorange: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            teallime: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            redyellow: 'relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md',
            pink: '',
        },
        hover: {
            default: 'group-hover:bg-opacity-0',
            purpleblue: 'group-hover:bg-opacity-0',
            cyanblue: 'group-hover:bg-opacity-0',
            greenblue: 'group-hover:bg-opacity-0',
            purplepink: 'group-hover:bg-opacity-0',
            pinkorange: 'group-hover:bg-opacity-0',
            teallime: 'group-hover:bg-opacity-0',
            redyellow: 'group-hover:bg-opacity-0',
            pink: '',
        },
        disabled: {
            default: 'cursor-not-allowed opacity-50',
            purpleblue: 'cursor-not-allowed opacity-50',
            cyanblue: 'cursor-not-allowed opacity-50',
            greenblue: 'cursor-not-allowed opacity-50',
            purplepink: 'cursor-not-allowed opacity-50',
            pinkorange: 'cursor-not-allowed opacity-50',
            teallime: 'cursor-not-allowed opacity-50',
            redyellow: 'cursor-not-allowed opacity-50',
            pink: 'cursor-not-allowed opacity-50',
        },
    }
};

//Select 스타일
//https://flowbite.com/docs/forms/input-field/#input-fields
const selectClasses = {
    default: {
        default: 'bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
        success: 'bg-green-50 border-green-500 dark:border-green-500 text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500 focus:ring-green-500 focus:border-green-500',
        error: 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500',
        disabled: 'cursor-not-allowed bg-gray-100',
    },
    underline: {
        default: 'bg-transparent dark:bg-transparent border-b-2 border-gray-200 appearance-none dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer',
        success: 'bg-green-50 border-green-500 dark:border-green-500 text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500 focus:ring-green-500 focus:border-green-500',
        error: 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500',
        disabled: 'cursor-not-allowed bg-gray-100',
    }
};

//탭 스타일
//https://flowbite.com/docs/components/tabs/#default-tabs
const tabClasses = {
    default: {
        default: 'cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300',
        active: 'cursor-pointer inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500',
        disabled: 'inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500',
    },
    underline: {
        default: 'cursor-pointer inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group',
        active: 'cursor-pointer inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group',
        disabled: 'inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500',
    },
    pills: {
        default: 'cursor-pointer inline-block py-3 px-4 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white',
        active: 'cursor-pointer inline-block py-3 px-4 text-white bg-blue-600 rounded-lg active',
        disabled: 'inline-block py-3 px-4 text-gray-400 cursor-not-allowed dark:text-gray-500',
    }
};

export default function(styleName, component, disabled, variant) {
    const theme = useFlowbiteThemable()
    let styleKey = '';
    let themeClasses = '';

    //테마 클래스 매칭
    if (theme.isActive) {
        switch (component) {
            case 'label':
            case 'input':
            case 'button':
            case 'select':
            
                
                break;
            case 'tab':
                if (variant == 'default') themeClasses = theme.text;
                else if (variant == 'underline') themeClasses = theme.text;
                else if (variant == 'pills') themeClasses = theme.background;
            default:
                themeClasses = '';
        }
    }

    if (styleName == undefined || styleName == '') styleKey = 'default';
    else styleKey = styleName;

    if (variant == undefined || variant == '') variant = 'default';

    //컴포넌트별 스타일 가져오기
    try {
        switch (component) {
            case 'label':
                if (disabled) styleKey = 'disabled';
                return twMerge(labelClasses[variant]['default'], labelClasses[variant][styleKey]);
            case 'input':
                if (disabled) styleKey = 'disabled';
                return twMerge(inputClasses[variant]['default'], inputClasses[variant][styleKey]);
            case 'button':
                console.log(variant);
                console.log(styleKey);
                if (disabled == 'disabled') {
                    return twMerge(buttonClasses[variant]['default'][styleKey], buttonClasses[variant]['disabled'][styleKey]);
                } else {
                    return twMerge(buttonClasses[variant]['default'][styleKey], buttonClasses[variant]['hover'][styleKey]);
                }
                break;
            case 'select':
                if (disabled) styleKey = 'disabled';
                return twMerge(selectClasses[variant]['default'], selectClasses[variant][styleKey]);
            case 'tab':

                return simplifyTailwindClasses(tabClasses[variant][styleKey], '');
            default:
                return '';
        }
    } catch (e) {
        console.log(e);
        return 'error-options';
    }
}


// 매처 맵은 특정 유형의 Tailwind 클래스를 매칭하는 함수를 포함합니다.
const classTypeMatchers = {
    border: function (_class) {
        return _class.substring(0, _class.lastIndexOf('-'));
    },
};

// 클래스의 유형을 매처 맵을 사용하여 가져옵니다.
function getTypeFromClass(_class, matchers) {
    matchers = matchers || classTypeMatchers;
    const classesToMatch = Object.keys(matchers);
    const matchClass = classesToMatch.find(function (_matchClass) {
        return _class.includes(_matchClass);
    });
    if (!matchClass) return _class.substring(0, _class.indexOf('-'));

    return matchers[matchClass](_class);
}

// 여러 Tailwind 클래스를 단순화하여 중복을 제거합니다.
function simplifyTailwindClasses() {
    var classes = Array.prototype.slice.call(arguments);

    return classes.filter(function (_) {
        return _;
    }).reduce(function (acc, value) {
        var currentClasses = Array.isArray(value)
            ? Array.from(value).map(function (_) {
                return _.split(' ');
            }).flat()
            : value.split(' ');
        var currentTypes = currentClasses.map(function (_class) {
            return getTypeFromClass(_class);
        });

        var typesToAdd = currentTypes.filter(function (_) {
            return !acc.types.includes(_);
        });
        var typesToReplace = currentTypes.filter(function (_) {
            return acc.types.includes(_);
        });
        var newTypes = typesToReplace.concat(typesToAdd);

        var types = Array.from(new Set(acc.types.concat(newTypes)));
        var classes = types.map(function (type) {
            if (newTypes.includes(type)) {
                var classIndex = currentTypes.indexOf(type);
                if (classIndex >= 0) { return currentClasses[classIndex] || ''; }
            }
            var classIndex = acc.types.indexOf(type);
            if (classIndex >= 0) { return acc.classes[classIndex] || ''; }
            return '';
        }).filter(function (_) { return !!_; });

        return {
            types: types,
            classes: classes,
        };
    }, { types: [], classes: [] }).classes.join(' ');
}

// 사용 예시
// console.log(simplifyTailwindClasses('dark:background-red-600 background-red text-400-black', 'dark:background-blue', 'text-600-white', 'dark:background-red-600'));